import { SetupContext } from 'vue-demi'
import { AnalyticsEvent, ActionEvent, SmartblockEvent } from '../types'

export function defineSmartblockEventEmits () {
  return {
    'call-event' (payload: SmartblockEvent) { return payload?.event != null },
    'analytics' (payload: AnalyticsEvent) { return payload?.event != null },
    'action' (payload: ActionEvent) { return payload != null }
  }
}
/**
 * Bubble up smartblock events to parents
 * @param context
 * @returns listeners
 */
export function useBypassSmartblockEvents (context: SetupContext<ReturnType<typeof defineSmartblockEventEmits>>) {
  // Just bypass events
  const onSmartblockEvent = (e: SmartblockEvent): void => { context.emit('call-event', e) }
  const onAnalytics = (e: AnalyticsEvent): void => { context.emit('analytics', e) }
  const onAction = (e: ActionEvent): void => { context.emit('action', e) }
  return {
    onSmartblockEvent,
    onAnalytics,
    onAction
  }
}
